import {gsap} from 'gsap'
import { smootherStop } from "./parallax";

window.mobilePopupTl = gsap.timeline({
     paused: true
})


export default function formInit() {
     const formContainer = document.querySelector(".form__container");
     // if form is not available below stmt return and skip further execution.
     if (!formContainer) return;


     // input label active function
     const inputFields = formContainer.querySelectorAll("input, textarea");

     inputFields.forEach((_input) => {
          _input.onblur = function () {
               _input.parentElement.classList.remove("active");
          };
          _input.onfocus = function () {
               _input.parentElement.classList.add("active");
          };
     });




     const formSmallTrigger = document.querySelector(".form-small-trigger");
     if (!formSmallTrigger) return;


     const mobilePopup = document.querySelector("#mobilepopup");
     const popupElements = Array.from(document.querySelectorAll('#mobilepopup .form__inner, #mobilepopup .mobile__close'))
     const _form = { open: false };


     mobilePopupTl
          .from(mobilePopup, {durtation: 1.5, xPercent:110, ease:'power3.out'}, 0)
          .from(popupElements, {duration: 0.75, xPercent: 10, opacity:0, autoAlpha:0, ease:'power4.inOut', stagger: 0.1},0)


     // popup open function
     function smallFormTriggerfn() {
          const formContainer = document.querySelector(".form__container");
          formSmallTrigger.addEventListener("click", (e) => {
               e.preventDefault();

               var pageId = document.querySelector('html#gbs_ps_remediad');
               if(pageId){
                    window.lintrk('track', { conversion_id: 8992452 });
               }

               // var remediadPageId = document.querySelector('html#remediadpage')
               // if(remediadPageId){
               //      window.lintrk('track', { conversion_id: 8992452 });
               // }


               mobilePopup.classList.add("active");
               mobilePopupTl.play().then(() => {
                    document.getElementById("name").focus();
               })
               document.body.style.overflowY = "scroll";



               if (Modernizr.touchevents) {
                    // supported
                  } else {
                       smootherStop();
                  }
          });
     }
     smallFormTriggerfn();

     // Popup close by click event
     const mobileClose = document.querySelector(".contact-mobile-close");


     
     mobilePopup.addEventListener("click", function (e) {
          if (e.target.tagName === "ASIDE") {
               mobilePopupTl.reverse().then(() => {
                    this.classList.remove("active");
                    document.body.style.overflow = "auto";
                    formSmallTrigger.focus();
             if (Modernizr.touchevents) {
               // supported
             } else {
                    smootherStop();
             }
               })

          }
     },false);

     window.closeContactPopup = () => {
          
          mobilePopupTl.reverse().then(() => {
               mobileClose.classList.remove("active");
               document.body.style.overflow = "auto";
               formSmallTrigger.focus();

        if (Modernizr.touchevents) {
          // supported
        } else {
               smootherStop();
        }

        })

     
}


     mobileClose.addEventListener("click", closeContactPopup, false);


}


